<cc-top-bar [title]="'MENU.DASHBOARD'">
</cc-top-bar>

<div class="container">
  <gridster
    #gridster
    [options]="options"
  >
    <gridster-item
      [item]="item"
      *ngFor="let item of dashboard">
      <div class="header">
        <div class="header-title" translate>{{item.title}}</div>
        <div *ngIf="item.showLast30days" class="header-right" translate>LEAD_GENERATION.PROJECTS.LAST_30_DAYS</div>
      </div>
      <ndc-dynamic
        [ndcDynamicComponent]="dynamicComponents[item.component]"
        [ndcDynamicInputs]="item.inputs"
      ></ndc-dynamic>
    </gridster-item>
  </gridster>
</div>

